import { createContext, useContext, ReactNode } from 'react'
import type { Player, TurnPermissions, TurnState } from '@/types/turn'

export interface TurnContextValue {
  // Estado
  turnState: TurnState | null
  currentPlayer?: Player | null
  permissions: TurnPermissions
  players: Player[]

  // Acoes
  onAdjustTime: (seconds: number) => void
  onNextPlayer: () => void
  onEndTurn: () => void
  onStartTurn: (config: { playerOrder: Player[], timeLimit: number }) => void
  onPauseTurn: () => void
  onStartCountdown: () => void

  // Utilitarios
  formatTime: (seconds: number) => string
}

const TurnContext = createContext<TurnContextValue | null>(null)

interface TurnProviderProps {
  children: ReactNode
  value: TurnContextValue
}

export function TurnProvider({ children, value }: TurnProviderProps) {
  return (
    <TurnContext.Provider value={value}>
      {children}
    </TurnContext.Provider>
  )
}

export function useTurnContext(): TurnContextValue {
  const context = useContext(TurnContext)
  if (!context) {
    throw new Error('useTurnContext must be used within a TurnProvider')
  }
  return context
}

// Hook opcional que retorna null se nao estiver dentro do provider
export function useTurnContextOptional(): TurnContextValue | null {
  return useContext(TurnContext)
}
